<script setup lang="ts">
import { onMounted, ref } from 'vue'

interface TurnstileObject {
  render: (element: HTMLElement, options: {
    'sitekey': string
    'callback': (token: string) => void
    'error-callback': (error: any) => void
  }) => string
}

const emit = defineEmits<{
  (event: 'input', token: string): void
}>()

declare const turnstile: TurnstileObject

const turnstileContainer = ref<HTMLElement>()

onMounted(() => {
  if (!turnstileContainer.value)
    throw new Error('TURNSTILE: element not found')
  turnstile.render(turnstileContainer.value, {
    'sitekey': window.injectedEnv.FRONTEND_CLOUDFLARE_TURNSTILE_SITEKEY,
    callback(token) {
      emit('input', token)
    },
    'error-callback': (error) => {
      console.error(`TURNSTILE: widget`, error)
    },
  })
})
</script>

<template>
  <div ref="turnstileContainer" />
</template>
